//@ts-check
import React, {Component} from 'react';
import {func, shape} from 'prop-types';
import classNames from 'classnames';
import {sourcesShape} from './Sources';
import styles from './Sources.scss';
import TagCloud from 'components/TagCloud';
import Tag from 'components/Tag';

class SourceTab extends Component {
    static propTypes = {
        propertySources: shape(sourcesShape),
        onRemoveTag: func.isRequired,
        addIncludedSourceTag: func.isRequired,
        addExcludedSourceTag: func.isRequired,
    };

    onAddSourceTagClick = includedOrExcluded => inputValue => {
        if (includedOrExcluded === 'included') {
            this.props.addIncludedSourceTag(inputValue);
        } else if (includedOrExcluded === 'excluded') {
            this.props.addExcludedSourceTag(inputValue);
        }
    };

    onClickNetworkButtonHandler = ({
        target: {
            dataset: {name},
        },
    }) => this.props.addIncludedSourceTag(name);

    onClickRemoveTag = (sourcesLens, name) => () => {
        this.props.onRemoveTag(sourcesLens, name);
    };

    // eslint-disable-next-line react/display-name
    renderSourceTag = sourcesLens => source => {
        const sourceClass = sourcesLens === 'excludedSources' ? styles.excludedSource : styles.includedSource;
        return (
            <div className={classNames(styles.tagList, sourceClass)}>
                <Tag
                    key={source.name}
                    className={styles.tag}
                    onRemoveTag={this.onClickRemoveTag(sourcesLens, source.name)}
                    header={source.name}
                    tagBody="Source"
                    locked={source.locked}
                />
            </div>
        );
    };

    renderIncludedTags = this.renderSourceTag('includedSources');

    renderExcludedTags = this.renderSourceTag('excludedSources');

    render() {
        const {propertySources} = this.props;
        const {excludedSources, includedSources} = propertySources;
        return (
            <div className={styles.Sources}>
                <div className={styles.row}>
                    <h3 className={styles.psH3}>Allowed Sources</h3>
                    <div className="sda-source-quick-picks">
                        <a
                            onClick={this.onClickNetworkButtonHandler}
                            className="sda-source"
                            id="source-abc"
                            data-name="ABC"
                        />
                        <a
                            onClick={this.onClickNetworkButtonHandler}
                            className="sda-source"
                            id="source-nbc"
                            data-name="NBC"
                        />
                        <a
                            onClick={this.onClickNetworkButtonHandler}
                            className="sda-source"
                            id="source-cbs"
                            data-name="CBS"
                        />
                        <a
                            onClick={this.onClickNetworkButtonHandler}
                            className="sda-source"
                            id="source-fox"
                            data-name="FOX"
                        />
                        <a
                            onClick={this.onClickNetworkButtonHandler}
                            className="sda-source"
                            id="source-cw"
                            data-name="CW"
                        />
                        <a
                            onClick={this.onClickNetworkButtonHandler}
                            className="sda-source"
                            id="source-cnn"
                            data-name="CNN"
                        />
                        <a
                            onClick={this.onClickNetworkButtonHandler}
                            className="sda-source"
                            id="source-ap"
                            data-name="AP"
                        />
                    </div>
                    <TagCloud
                        placeholder="Enter source"
                        tags={includedSources.map(this.renderIncludedTags)}
                        addTag={this.onAddSourceTagClick('included')}
                    />
                </div>

                <div className={styles.row}>
                    <h3 className={styles.psH3}>Prohibited Sources</h3>
                    <TagCloud
                        placeholder="Enter source"
                        tags={excludedSources.map(this.renderExcludedTags)}
                        className={styles.tagList}
                        addTag={this.onAddSourceTagClick('excluded')}
                    />
                </div>
            </div>
        );
    }
}

export default SourceTab;
